import { render, staticRenderFns } from "./CardContentDefaultPublicMicro.vue?vue&type=template&id=0d823fa0&scoped=true&"
import script from "./CardContentDefaultPublicMicro.vue?vue&type=script&lang=js&"
export * from "./CardContentDefaultPublicMicro.vue?vue&type=script&lang=js&"
import style0 from "./CardContentDefaultPublicMicro.vue?vue&type=style&index=0&id=0d823fa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d823fa0",
  null
  
)

export default component.exports